import { createStore } from 'vuex'

const store = createStore({
// state，mutations，actions和getters等选项
  state: {
    dbid:'',
    dbname:'',
    userInfo:{},
  },
  mutations: {
    setDbid(state,data) {
      state.dbid = data;
    },
    setDbname(state,data){
      state.dbname = data;
    },
    setUserInfo(state,data){
      state.userInfo = data;
    }
  },
  getters: {
    getDbid(state) {
      return state.dbid;
    },
    getDbName(state){
      return state.dbname;
    },
    getUserInfo(state){
      return state.userInfo;
    }
  }
})

export default store
